'use client';

import React from 'react';
import type { Breadcrumb } from '@benzinga/content-manager';
import { usePathname } from 'next/navigation';
import { HeroPageHeader } from '../../../_components/LayoutPageHeader/HeroPageHeader';
import { BENZINGA_ORIGIN, normalizeScreenerPath } from '../screenerMeta';
import { ScreenerPresentedBy } from './ScreenerPresentedBy';

export interface ScreenerPageHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  url?: string;
  bottomContent?: React.ReactNode;
  presentedBy?: string;
  presentedByLink?: string;
  tabs?: {
    key: string;
    label: string;
    href: string;
  }[];
  breadcrumbs?: Breadcrumb[];
}

export function ScreenerPageHeader({
  title,
  subtitle,
  description,
  url,
  tabs,
  bottomContent,
  presentedBy,
  presentedByLink,
  breadcrumbs = [
    { href: '/tools', id: 'tools', name: 'Tools' },
    { href: '/screener', id: 'screener', name: 'Stock Screeners' },
  ],
}: ScreenerPageHeaderProps) {
  const currentPath = normalizeScreenerPath(usePathname());
  const canonical = url ?? `${BENZINGA_ORIGIN}${currentPath}`;

  return (
    <HeroPageHeader
      bottomContent={bottomContent}
      breadcrumbs={breadcrumbs}
      buttonLocation="screener_page"
      canonical={canonical}
      className="screener-page-header"
      description={description}
      leadingContent={presentedBy ? <ScreenerPresentedBy link={presentedByLink} logo={presentedBy} /> : undefined}
      navAriaLabel="Stock screener pages"
      showEdgeBadge
      subtitle={subtitle}
      tabs={tabs?.map(tab => ({
        href: tab.href,
        id: tab.key,
        isActive: currentPath === normalizeScreenerPath(tab.href),
        label: tab.label,
      }))}
      title={title}
    />
  );
}
